export default __webpack_public_path__ + "static/media/viber_image_2022-06-02_10-09-21-089.40c18b45.jpg";